export const SECRET_CAT_EASTER_EGG_SEQUENCE = 'c a t';

export const SECRET_CAT_ASCII = String.raw`
 /\_/\\
( o.o )
 > ^ <
`;

export const SECRET_CAT_MEOW = 'meow';
